<template>
  <div
    v-show="isShowed"
    class="relative mx-auto my-11 grid w-fit select-none grid-flow-col place-content-center gap-1.5 overflow-hidden p-5 text-new-red-dark lg:gap-3"
  >
    <NuxtLink
      v-if="prevUrl && !isMobile"
      rel="prev"
      class="pagination-item prevnext grid grid-flow-col items-center gap-1"
      :to="{
        query: { ...route.query, page: page > 2 ? page - 1 : undefined },
      }"
    >
      <SvgIcon name="chevron-left" class="size-4" />
      <span>Назад</span>
    </NuxtLink>

    <template v-if="page > offset && !paginatePages.includes(1)">
      <NuxtLink
        :key="`1-first`"
        class="pagination-item"
        :to="{ query: { ...route.query, page: undefined } }"
        >1</NuxtLink
      >
      <div v-if="paginatePages[0] > 2" class="pagination-item dots">...</div>
    </template>

    <template v-for="i in paginatePages" :key="`${i}-middle`">
      <NuxtLink
        class="pagination-item"
        :class="{
          active: page === i,
        }"
        :to="{ query: { ...route.query, page: i > 1 ? i : undefined } }"
      >
        {{ i }}
      </NuxtLink>
    </template>

    <template v-if="page < totalPages - offset">
      <div
        v-if="
          totalPages - paginatePages[paginatePages.length - 1] > 1 &&
          !paginatePages.includes(totalPages)
        "
        class="pagination-item dots"
      >
        ...
      </div>
      <NuxtLink
        v-if="!paginatePages.includes(totalPages)"
        :key="`${totalPages}-last`"
        class="pagination-item"
        :to="{ query: { ...route.query, page: totalPages } }"
      >
        {{ totalPages }}
      </NuxtLink>
    </template>

    <NuxtLink
      v-if="nextUrl && !isMobile"
      rel="next"
      class="pagination-item prevnext grid grid-flow-col items-center gap-1"
      :to="{ query: { ...route.query, page: page + 1 } }"
      ><span>Вперед</span><SvgIcon name="chevron-right" class="size-4"
    /></NuxtLink>
  </div>
</template>

<script setup>
const props = defineProps({
  entity: {
    type: Object,
    required: true,
  },
});

const route = useRoute();
const { isMobile } = useBreakpoint();

const { offset, isShowed, paginatePages, totalPages, page } =
  usePaginationHelper(props.entity);

const { getAbsoluteUrl } = useSeoHelper();

const prevUrl = computed(() => {
  if (page.value > 1) {
    const path =
      page.value > 2 ? route.path + '?page=' + (page.value - 1) : route.path;
    return getAbsoluteUrl(path);
  }
  return null;
});

const nextUrl = computed(() => {
  if (page.value < totalPages.value) {
    const path = route.path + '?page=' + (page.value + 1);
    return getAbsoluteUrl(path);
  }
  return null;
});

useHead(() => ({
  link: [
    prevUrl.value && {
      rel: 'prev',
      href: prevUrl.value,
      hid: 'prev-link',
    },
    nextUrl.value && {
      rel: 'next',
      href: nextUrl.value,
      hid: 'next-link',
    },
  ].filter(Boolean),
}));
</script>

<style>
.pagination-item {
  @apply p-2 lg:px-3 font-roboto uppercase text-[18px] leading-[18px] text-new-test-black rounded border border-[#E9E9E9] w-fit cursor-pointer lg:min-w-[40px] min-w-[24px] lg:min-h-[40px] min-h-[24px] grid place-content-center active:bg-collection/30 active:text-white-100 transition-colors duration-300 ease-in;

  &.prevnext {
    @apply text-[16px] leading-4;
  }
  &.active {
    @apply bg-collection text-white-100;
  }
  &.dots {
    @apply cursor-default max-lg:px-1;
  }
}
</style>
